import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-950 text-center mb-2">话题热榜</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">全网热议话题实时追踪</p>
        <div className="flex flex-wrap justify-center gap-3 md:gap-4">
          {topicsData.map((topic) => (
            <a
              key={topic.id}
              href="#carousel"
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-primary-50/50 transition-colors cursor-pointer"
            >
              {topic.hot && (
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                </span>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}